import { useLocation, useNavigate } from "react-router";
import useFetch from "../../hooks/useFetch";
import React, { useEffect, useState } from "react";
import { create } from "../../services/upload-files.service";
import { Link } from "react-router-dom";
import { exportToExcel } from "../../services/fetch-data.service";
const EXPORT_SASBREPORT_API = 'https://dev.sustainabilitypro.io/api/v1/sasb/export_sasb_data?company_id=1&year=2025'

const SasbForm = () => {
    // const [formValues, setFormValues] = useState({});

    const userdetails = JSON.parse(localStorage.getItem('userdetails'))
    const [sasbReportData, setSasbReportData] = useState([]);
    const { state } = useLocation();
    const year = new Date().getFullYear();
    const { data, isLoading: isSasbLoading } = useFetch('sasb/template');
    const { data: companyData, isLoading: isCompanyLoading } = useFetch(`sasb/details?company_id=${userdetails.company_id}&year=${year}`);
    const [isSaving, setIsSaving] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        if (!isCompanyLoading) {
            const dataToSet = Object.keys(companyData).length > 0 ? companyData.data.data

                : data.data;
            setSasbReportData(dataToSet);
        }

    }, [companyData, data, isCompanyLoading]);
    

   



    const handleChange = (label, value) => {
        const updatedFormValues = sasbReportData.map(formData => {
            const updatedQuestions = formData.questions.map(qus => {
                if (qus.type === 'textarea' && qus.question === label) {
                    return {
                        ...qus,
                        answer: value || '',
                    };
                }
                if (qus.type === 'number' && qus.question === label) {
                    return {
                        ...qus,
                        answer: value || '',
                    };
                }
                return qus;
            });
            return {
                ...formData,
                questions: updatedQuestions,
            };
        });

        setSasbReportData(updatedFormValues);
    };

    const saveData = (dataToSave) => {

        setIsSaving(true); // Set saving indicator
        create(dataToSave, 'sasb/savesasb')
        .then(res => {
            console.log(res);
        })
            .finally(() => {
                setIsSaving(false); // Reset saving indicator
            });
    };

    const handleSubmit = event => {
        event.preventDefault();
        const submitData = {
            company_id: userdetails.company_id,
            module_name: 'General Disclosure',
            year: year,
            data: sasbReportData,
        };
        setIsSaving(true); // Set saving indicator
        saveData(submitData);
    };

    const exportSasbReport = () => {
        exportToExcel(EXPORT_SASBREPORT_API, 'sasbReport')
    };

    const goBack = () => navigate(-1);

    if (isSasbLoading || isCompanyLoading || isSaving) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </div>
            </main>
        );
    }

    let displayedStandards = '';

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <div className="fixed-div">
                    <div className="h2">
                        <Link onClick={goBack}>
                            <i className="fas fa-arrow-left"></i>
                        </Link>
                        SASB
                    </div>
                    <div className="buttons-right">
                        <button className="btn btn-primary btn-add" onClick={() => saveData({
                            company_id: userdetails.company_id,
                            module_name: 'General Disclosure',
                            year: year,
                            data: sasbReportData,
                        })}>
                            Save 
                        </button>
                        
                    <button className='btn btn-primary btn-add' onClick={exportSasbReport} > <i class="fa-solid fa-file-import"></i> Export Report </button>
                
                    </div>
                </div>
            </div>
            <div className="form-div">
                <form onSubmit={handleSubmit}>
                    <div className="mt-3 griform">
                        {sasbReportData && sasbReportData.map((formData, index) => (
                            <React.Fragment key={index}>
                                {displayedStandards !== formData.standard && <h5><b>{formData.standard}</b></h5>}
                                {(() => { displayedStandards = formData.standard })()}
                                <div className="question-container sasb">

                                    <h6><b>{formData.disclosure}</b></h6>

                                    {formData.questions &&
                                        formData.questions.map((qus) => (

                                            <div key={qus.question} className="answer-container">
                                                <div className="sasbinnerblocks" key={qus.question}>
                                                    <label htmlFor={qus.question}><b>{qus.question} </b> </label>
                                                    <label htmlFor={qus.title}><b>{qus.title} </b> </label>
                                                    {qus.type === 'textarea' && (
                                                        <textarea
                                                            className="form-control"
                                                            id={qus.question}
                                                            name={qus.question}
                                                            value={qus.answer}
                                                            onChange={(e) => handleChange(qus.question, e.target.value)}
                                                            rows="3" cols="50"
                                                        />
                                                    )}
                                                    {qus.type === 'number' && (
                                                        <input
                                                            id={qus.question}
                                                            type="number"
                                                            className="form-control"
                                                            step="0.001"
                                                            min="0"
                                                            name={qus.question}
                                                            value={qus.answer}
                                                            onChange={(e) => handleChange(qus.question, e.target.value)}

                                                        />
                                                    )}
                                                </div>
                                            </div>

                                        ))}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                    <div className="mt-3 mb-3">
                        <button className="btn btn-primary btn-add" type="submit">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </main>
    );
}

export default SasbForm;
